import { render, staticRenderFns } from "./TextInputForm.vue?vue&type=template&id=c21c53d0&"
import script from "./TextInputForm.vue?vue&type=script&lang=js&"
export * from "./TextInputForm.vue?vue&type=script&lang=js&"
import style0 from "./TextInputForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports